module.exports = __webpack_public_path__ + "87c542e7.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/videos3.png
// module id = 1341
// module chunks = 6